import styles from "./ringsBackground.module.css"

/**
 * Landing page background rebuilt from the Figma "thumbnail" frame
 * (App-Icons, node 67:177). Layers are ordered bottom-to-top to match
 * the Figma z-order; geometry and paint specs live in the module CSS.
 */
function RingsBackground({
  style,
  washless = false,
}: {
  style?: React.CSSProperties
  /** Rings only — no backdrop fill, no gradient wash (hero use). */
  washless?: boolean
}) {
  return (
    <div
      className={washless ? `${styles.root} ${styles.washless}` : styles.root}
      style={style}
      aria-hidden="true"
    >
      <div className={styles.stage}>
        <div className={styles.darkIcon} />
      </div>
      <div className={styles.rings}>
        <div className={`${styles.ellipse} ${styles.ring} ${styles.ellipse1}`} />
        <div className={styles.rect10} />
        <div className={`${styles.ellipse} ${styles.ring} ${styles.ellipse7}`} />
        <div className={`${styles.ellipse} ${styles.ring} ${styles.ellipse2}`} />
        <div className={`${styles.ellipse} ${styles.ring} ${styles.ellipse6}`} />
        <div className={`${styles.ellipse} ${styles.dot}`} />
        <div className={`${styles.ellipse} ${styles.ring} ${styles.ellipse4}`} />
      </div>
    </div>
  )
}

export { RingsBackground }
